import { combineReducers } from 'redux';
import cartReducer from './cartReducer';

// 추후 다른 리듀서들도 추가할 수 있음
const rootReducer = combineReducers({
  cart: cartReducer,
  // 다른 리듀서들...
});

export default rootReducer;